export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Line from"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["to"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["symbols"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invalid value"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Required Field"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check the fields"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Latin letters"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cyrillic letters"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["numbers"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["special characters"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allowed characters:"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["max."])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SVG, PNG or JPG"])}
}